import { Phone, Mail } from "lucide-react";
import { Reveal, KineticText } from "./Reveal";

export const LegalPage = ({ eyebrow, titleLines, intro, sections, testid }) => (
    <main className="pt-36 sm:pt-44 pb-24">
        <div className="mx-auto max-w-3xl px-5 sm:px-8" data-testid={testid}>
            <Reveal>
                <p className="eyebrow">{eyebrow}</p>
            </Reveal>
            <h1 className="mt-7 f-display text-[clamp(2.4rem,6.5vw,4.5rem)] font-black uppercase leading-[0.98] tracking-tighter text-white">
                <KineticText delay={0.2} lines={titleLines} />
            </h1>
            <Reveal delay={0.1}>
                <p className="mt-7 text-base leading-relaxed text-slate-400">{intro}</p>
            </Reveal>

            <div className="mt-14 space-y-8">
                {sections.map((s, i) => (
                    <Reveal key={i}>
                        <div className="legal-row">
                            <span className="f-mono text-sm text-[#00F0FF]">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <div>
                                <h2 className="f-display text-lg font-bold tracking-tight text-white">
                                    {s.h}
                                </h2>
                                <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-400">
                                    {s.p.map((para, j) => (
                                        <p key={j}>{para}</p>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal>
                <div className="mt-16 rounded-2xl border border-[#FF5500]/25 bg-[#FF5500]/8 p-7">
                    <p className="f-mono text-[10px] uppercase tracking-[0.25em] text-[#FF5500]">
                        Questions about this policy?
                    </p>
                    <div className="mt-4 flex flex-wrap gap-6">
                        <a
                            href="mailto:zyne6431@gmail.com"
                            data-testid="legal-email-link"
                            className="flex items-center gap-2.5 text-sm font-semibold text-white hover:text-[#FF5500] transition-colors"
                        >
                            <Mail size={16} className="text-[#FF5500]" />
                            zyne6431@gmail.com
                        </a>
                        <a
                            href="tel:+916207984279"
                            data-testid="legal-phone-link"
                            className="flex items-center gap-2.5 text-sm font-semibold text-white hover:text-[#FF5500] transition-colors"
                        >
                            <Phone size={16} className="text-[#FF5500]" />
                            +91 6207984279
                        </a>
                    </div>
                </div>
            </Reveal>
        </div>
    </main>
);

export default LegalPage;
